import React from 'react'
import { useNavigate } from 'react-router-dom'

const ListItem = ({className,Title,Icon,to}) => {
  const navigate=useNavigate()

  const handleClick = () => {
    navigate(to);   // navigation ONLY on click
  };
  
  return (
    <>
    

       <button className={`nav-item ${className}`}
       onClick={handleClick}
       >
             <span className="nav-icon">
       {Icon}
      </span>
            <span>{Title}</span>
          </button>
    </>
  )
}

export default ListItem